import React, { useEffect, useState } from 'react';
import HeaderComponent from '../../components/header';
import { useQuery } from 'react-query';
import { getItemOfSessionStorage } from '../../services/common/utils';
import { useSelector } from 'react-redux';
import VerificationPACI from './verification-paci';
import VerificationOTP from './verification-otp';
import VerificationConfirmation from './verification-confirmation';
import ErrorComponent from '../../components/common/error';
import PageShimmer from '../../components/loader/skeletons/common/page-shimmer';
import { CDR_SETTINGS } from '../../services/common/endpoints';
import AuthenticatingUserShimmer from '../../ShimmerEffect/AuthenticatingUserShimmer';
import { CT_Events } from '../../analytics/CTEvents';
import { GTMScreenView } from '../../analytics/GoogleTagManager';

const TwoStepVerification = () => {

  const otpCheckSucces = useSelector((state) => state?.userdata?.OTPCheck);
  const [radioCheck, setRadioCheck] = useState('');
  const [cdrData, setCdrData] = useState('');
  const {CT_ScreenView} = CT_Events();
  const logintype = useSelector((state) => state?.userdata?.value?.loginmode);
  const msisdn = useSelector((state) => state?.userdata?.value?.selectedmsisdn);
  const [cdrResponse, setCdrResponse] = useState(false);
  const [otpverificationconfigurations, setOtpverificationconfigurations] = useState('');
  const [paciverificationconfigurations, setPaciverificationconfigurations] = useState('');
  const {data: {data}={}, isLoading, isFetching} = useQuery(["cdr-settings", CDR_SETTINGS, {}, {}, false, 'cdr'],
  {
      enabled: true,
      retry: false,
      onSuccess:({data: udata})=>{
        if(data?.status !== -1){
          setCdrData(udata?.response?.verificationconfigurations);
          setRadioCheck(udata?.response?.verificationconfigurations?.step_1);
          setOtpverificationconfigurations(udata?.response?.otpverificationconfigurations);
          setPaciverificationconfigurations(udata?.response?.paciverificationconfigurations);
          setCdrResponse(udata?.response);
        }
      }
  })

  useEffect(() =>{
    try{
      GTMScreenView("Two_step_Verification", msisdn, logintype );
    }catch{}
    try{
      CT_ScreenView()
    }catch{}
  }, [])

  const verficationMethods = [
    {
      method: cdrData?.step_1,
      status: radioCheck === cdrData?.step_1 || radioCheck === cdrData?.step_2|| radioCheck === cdrData?.step_3
    },
    {
      method: cdrData?.step_2,
      status: radioCheck === cdrData?.step_2 || radioCheck === cdrData?.step_3
    },
    {
      method: cdrData?.step_3,
      status: radioCheck === cdrData?.step_3
    }
  ]

  const handleSwitch = (radioCheck)=>{
    let x= 
      radioCheck === cdrData?.step_1   ? "A" : radioCheck === cdrData?.step_2 ? "B" : radioCheck === cdrData?.step_3 ? "C" : ''
    if(cdrResponse){  
      switch(x){
        case 'A' : return (<VerificationOTP setRadioCheck={setRadioCheck} cdrResponse={cdrResponse} />)
        break;
        case 'B': return <VerificationPACI setRadioCheck={setRadioCheck} cdrResponse={cdrResponse}/> 
        break;
        case 'C' : return <VerificationConfirmation 
                              commonconfigurations={cdrResponse?.commonconfigurations} 
                              confirmationverificationconfigurations={cdrResponse?.confirmationverificationconfigurations}
                          />
        break;
        default : return <ErrorComponent/>
        break;

      }
  }
    
  }

  // if(isLoading || isFetching){
  //   return <AuthenticatingUserShimmer/>
  // }
  return (
    <div>
      <HeaderComponent type={15}></HeaderComponent>
      <div className='sprint17-verification-pg pse_sm sprint16bg pt-4 '>

        {isFetching || isLoading ? <AuthenticatingUserShimmer/> : 
        <>
         <div className='sprint17-lg-col'>
          <div className='sprint17-verification-heding'>
            <h6>{cdrData?.page_title}</h6>
            <p>{cdrData.page_desc} </p>
          </div>
        

          {/* radio button */}
          <div className="sprint17-verifi-sec01">
            {verficationMethods.map(item => (
              <div>
                <input id="radio-1" class="radio-custom" name="radio-group" type="checkbox" checked={item.status} disabled />
                <label for="radio-1" class="radio-custom-label">{item.method}</label>
              </div>
            ))}
          </div>
        </div>

        {cdrData && handleSwitch(radioCheck)}
        </>}
        {/* {radioCheck === "OTP_Check" && !otpCheckSucces && <OTPVerification setRadioCheck={setRadioCheck}/>}
        {radioCheck === "PACI_Check" &&
          getItemOfSessionStorage(IS_2FA_DONE) !== 'true' && <PaciVerification setRadioCheck={setRadioCheck}/> 
        }
        {radioCheck === "Confirmation_Check" && <SuccessComponenet />} */}
  
      </div>

  
    </div>
  )
}

export default TwoStepVerification;